export const masks = {
    classes: ['ctHidden', 'usabillaHidden'],
    attributes: ['data-mf-replace-inner'],
};
//# sourceMappingURL=masks.js.map